import CacheStore from './cache-store'

export default class AuthStore {
  public static storageKey: string = 'token'
  public static firstNameKey: string = 'user.firstname'
  public static lastNameKey: string = 'user.lastName'
  public static userIdKey: string = 'user.userId'
  public static isLDAPKey: string = 'user.isLdap'
  public static userNameKey: string = 'user.userName'

  public static getToken () {
    return CacheStore.getFromSession(CacheStore.TOKEN)
  }

  public static getFirstName () {
    return localStorage.getItem(AuthStore.firstNameKey)
  }

  public static getLastName () {
    return localStorage.getItem(AuthStore.lastNameKey)
  }

  public static getUserId () {
    return localStorage.getItem(AuthStore.userIdKey)
  }

  public static isLDAP () {
    return localStorage.getItem(AuthStore.isLDAPKey) === 'true'
  }

  public static getUserName () {
    return localStorage.getItem(AuthStore.userNameKey)
  }

  public static setToken (token: string, firstName: string, lastName: string, userId: string, isLDAP: boolean, userName: string) {
    localStorage.setItem(AuthStore.storageKey, token)
    localStorage.setItem(AuthStore.firstNameKey, firstName)
    localStorage.setItem(AuthStore.lastNameKey, lastName)
    localStorage.setItem(AuthStore.userIdKey, userId)
    localStorage.setItem(AuthStore.isLDAPKey, isLDAP ? 'true' : 'false')
    localStorage.setItem(AuthStore.userNameKey, userName)
  }

  public static removeToken (): void {
    localStorage.removeItem(AuthStore.storageKey)
    localStorage.removeItem(AuthStore.firstNameKey)
    localStorage.removeItem(AuthStore.lastNameKey)
    localStorage.removeItem(AuthStore.userIdKey)
    localStorage.removeItem(AuthStore.isLDAPKey)
    localStorage.removeItem(AuthStore.userNameKey)
  }

  public static isSignedIn (): boolean {
    return !!AuthStore.getToken()
  }

  public static getTokenData () {
    const token = AuthStore.getToken()
    if (token) {
      return JSON.parse(atob(token.split('.')[1]))
    }
    return {}
  }

  public static isResponsible (userId: any) {
    return userId === this.getUserId()
  }

  public static getAvatarName () {
    return this.getFirstName() + ' ' + this.getLastName()
  }

  public static getTrigram () {
    const username = '' + this.getUserName()
    return username != null ? username.substr(0, 3).toUpperCase() : ''
  }
}
